define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/table/New"
], function(declare,Controller,New) {

	return declare(New, {
		bNavigate: true,

		addProxyActions: function(/*View*/defView, /*Actions*/defActions) {
			// summary: change Save to Finish since navigating to new node
			defActions.addAction(this.getProxyAction("Finish", true, {m_bSubmit: true}));
			Controller.prototype.addProxyActions.call(this, defView, defActions);
		}
	});
});
